import { statsigImport } from '~/common/Statsig/hybridStatsig';
import type {
    StatsigClient as StatsigClientType,
    StatsigOptions,
    StatsigUser
} from '@statsig/js-client';
import type { Statsig as LegacyStatsigClient } from 'statsig-react';

let client: StatsigClientType | null = null;

type InitializeStatsigClientParams = {
    sdkKey: string;
    user: StatsigUser;
    options: StatsigOptions;
    onReady: (initDurationMs: number) => void;
    onError: (error: Error, message?: string) => void;
    initTimeoutMs?: number;
};

export const initializeStatsigClient = ({
    sdkKey,
    user,
    options,
    onReady,
    onError,
    initTimeoutMs = 3000
}: InitializeStatsigClientParams): StatsigClientType => {
    if (client) {
        return client;
    }

    const StatsigClient = statsigImport('StatsigClient');
    client = new StatsigClient(sdkKey, user, options);

    client
        .initializeAsync({ timeoutMs: initTimeoutMs })
        .then(value => {
            onReady(value.duration);
            return value;
        })
        .catch(error => onError(error, 'StatsigClient.initializeAsync error'));

    client.on('error', function (evt) {
        const error =
            evt.error instanceof Error
                ? evt.error
                : new Error(`[${evt.name}] ${evt.tag}`, {
                      cause: evt.error
                  });
        onError(error, 'StatsigClient.on error');
    });

    client.on('gate_evaluation', function (event) {
        window.DD_RUM?.addFeatureFlagEvaluation?.(
            event.gate.name,
            event.gate.value
        );
    });

    return client;
};

export const getStatsigClient = (): StatsigClientType | null => {
    return client;
};

export const getLegacyStatsigClient = () => {
    const {
        Statsig
    }: {
        Statsig: typeof LegacyStatsigClient;
        // eslint-disable-next-line @typescript-eslint/no-require-imports
    } = require('statsig-react');
    return Statsig;
};
